import { LoginService } from '../security/login.service';
import { inject } from '@angular/core';
import { of, switchMap } from 'rxjs';

export const authenticationGuard = () => {
  const loginService = inject(LoginService);

  if (loginService.isUserAuthenticated()) {
    return true;
  }

  // In-memory auth state (isLoggedIn) is lost on a full page reload/refresh, so a
  // user sitting on any funds page would otherwise be blocked here. Re-establish
  // the state from the server before deciding:
  //
  // 1. validateSession()/verifySession is SUCCESS-gated (the FNX cookie's
  //    AUTH_STATUS must be SUCCESS) and it resolves the user's persisted
  //    entitlement group FROM the cookie. That keeps a fully-authenticated user —
  //    on their current page without bouncing them back to entitlement selection.
  // 2. If the session is not SUCCESS, partial-auth users (sitting on the user
  //    agreement or entitlement selection page) get a 403 -> false. Fall back to
  //    login(), which re-derives the AUTH_STATUS and redirects to the correct
  //    page (userAgreement / selectFirm) or to the session-timeout /
  //    access-denied / error page. login() performs those redirects itself and
  //    sets isLoggedIn for the partial-auth states, so the follow-up navigation
  //    re-enters this guard and short-circuits above. We simply return its result.
  //
  // Note: we deliberately do NOT call login() for SUCCESS users, because login()
  // re-authenticates without an entitlementGroup and would return
  // ENTITLEMENT_MISSING for external users.
  return loginService
    .validateSession()
    .pipe(
      switchMap((sessionValid) =>
        sessionValid ? of(true) : loginService.login(),
      ),
    );
};
